import type { ReactNode } from 'react';
import { FontWeights } from '@newcore/ui/enums/font-weights';
import { TextSizes } from '@newcore/ui/enums/typography-text-sizes';
import { Text } from '@newcore/ui/typography';

interface InstallStepProps {
  number: number;
  children: ReactNode;
}

export function InstallStep({ number, children }: InstallStepProps) {
  return (
    <li className='flex items-start gap-3.5'>
      <Text
        as='span'
        size={TextSizes.XS}
        weight={FontWeights.SEMIBOLD}
        className='flex h-[26px] w-[26px] shrink-0 items-center justify-center rounded-full bg-primary-solid text-white'
      >
        {number}
      </Text>
      <Text as='span' size={TextSizes.MD} className='text-primary'>
        {children}
      </Text>
    </li>
  );
}
